import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import {
  DownOutlined,
  RightOutlined,
  ArrowRightOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../components/items";

import common from "../../../../utils/common";
import global from "../../../../config/global";

const MasterPasswordRequirements = (props) => {
  const { PolicyResult, RouterLink } = itemsComponents;
  const { t } = useTranslation();
  const { policy } = props;

  const allCiphers = useSelector((state) => state.cipher.allCiphers)

  const [expand, setExpand] = useState(false);

  const violatedItems = useMemo(() => {
    return common.violatedMasterPasswordCipher(allCiphers)
  }, [allCiphers]);

  return (
    <div className="mt-4">
      <div className="flex justify-between">
        <div
          className="flex text-primary cursor-pointer"
          onClick={() => setExpand(!expand)}
        >
          <p className="font-semibold text-xl mr-2">
            {t('policies.master_password_requirements.title')}
          </p>
          {
            expand ? <DownOutlined /> : <RightOutlined />
          }
        </div>
        <PolicyResult
          issues={violatedItems.length}
        />
      </div>
      <p className="mt-1">
        {t('policies.master_password_requirements.description')}
      </p>
      {
        expand && <div className="mt-4">
          <p className="font-semibold text-[16px] mb-2">{t('policies.policy_details')}</p>
          <p className="mb-1">{t('policies.master_password_requirements.policy_details_desc')}</p>
          <ul className="mb-1" style={{ listStyleType: 'circle', marginLeft: -24 }}>
            {
              policy?.config?.minLength > 0 && <li className="mb-1">
                {t('policies.password_requirements.minimum_password_length', { length: policy?.config?.minLength })}
              </li>
            }
            {
              policy?.config?.requireSpecialCharacter && <li className="mb-1">
                {t('policies.password_requirements.requires_special_character')}
              </li>
            }
            {
              policy?.config?.requireLowerCase && <li className="mb-1">
                {t('policies.password_requirements.requires_lowercase')}
              </li>
            }
            {
              policy?.config?.requireUpperCase && <li className="mb-1">
                {t('policies.password_requirements.requires_uppercase')}
              </li>
            }
            {
              policy?.config?.requireDigit && <li className="mb-1">
                {t('policies.password_requirements.requires_digit')}
              </li>
            }
          </ul>
          {
            violatedItems.length > 0 && <div className="mt-6">
              <RouterLink
                className={'font-semibold'}
                label={t('policies.master_password_requirements.change_master_password')}
                routerName={global.keys.SETTINGS_SECURITY}
                routerQuery={{ change_master_password: 1 }}
                type={'danger'}
                icon={<ArrowRightOutlined />}
              />
            </div>
          }
        </div>
      }
    </div>
  );
}

export default MasterPasswordRequirements;